import * as React from 'react';
import { useEffect } from "react";
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Button, Stack, Avatar, Chip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { key_ui_map_ql } from '../../../Utilities/Metrics';



function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'image',
    numeric: false,
    disablePadding: true,
    label: ''
  },
  {
    id: 'courier',
    numeric: false,
    disablePadding: false,
    label: 'Courier'
  },
  {
    id: 'warehouse',
    numeric: false,
    disablePadding: false,
    label: 'Warehouse'
  },
  {
    id: 'country',
    numeric: false,
    disablePadding: false,
    label: 'Country'
  },
  {
    id: 'ParcelifyName',
    numeric: false,
    disablePadding: false,
    label: 'Parcelify Name'
  },
  {
    id: 'ServiceName',
    numeric: false,
    disablePadding: false,
    label: 'Service Name'
  },
  {
    id: 'ShopifyReference',
    numeric: false,
    disablePadding: false,
    label: 'Shopify Reference'
  },
  {
    id: 'Currency',
    numeric: false,
    disablePadding: false,
    label: 'Currency'
  },
  {
    id: 'SnagPriceBase',
    numeric: false,
    disablePadding: false,
    label: 'Snag Price Base'
  },
  {
    id: 'SnagPriceVAT',
    numeric: false,
    disablePadding: false,
    label: 'Snag Price VAT'
  },
  {
    id: 'SnagPricePerKG',
    numeric: false,
    disablePadding: false,
    label: 'Snag Price Per KG'
  },
  {
    id: 'CourierBasePrice',
    numeric: false,
    disablePadding: false,
    label: 'Courier Base Price'
  },
  {
    id: 'CourierPerKG',
    numeric: false,
    disablePadding: false,
    label: 'Courier Per KG'
  },
  {
    id: 'CourierBasePrice6',
    numeric: false,
    disablePadding: false,
    label: 'Courier Base Price + 6%'
  }
];

function EnhancedTableHead(props) {

  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };


  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (

        <Stack direction="row"  sx={{ flex: '1 1 100%' }} alignItems="center">

        <Typography
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>

         {numSelected === 1 ? 
           <>

          <Button style={{marginLeft:8}}onClick={() => {props.handle_shipping_service_state("edit")}}>
            Edit
          </Button> 

          {/*<Button onClick={() => {props.handle_shipping_service_state("deploy")}}>
            Deploy
         </Button> */}
          
          </>
          
          : null}

          </Stack>

      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
        </Typography>
      )}

  
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton onClick={(event) =>{props.delete_shipping_services()}}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

 function ShippingServicesListTable(props) {

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  console.log("Shipping table rendered")

  const rows = [];

  const selected = React.useMemo(() => {

    return(props.all_shipping_services.filter((shipping_service) => shipping_service.is_checked).length)

  },[props.all_shipping_services])



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {

    const is_checked = event.target.checked;

    props.set_all_shipping_services((previous_shipping_services) => {

      var temp_shipping_services = [...previous_shipping_services]

      temp_shipping_services = temp_shipping_services.map((shipping_service) => {
  
        shipping_service.is_checked = is_checked;
  
        return(shipping_service);
  
      })

  
      return(props.set_all_shipping_services(temp_shipping_services))

    })

  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  // Avoid a layout jump when reaching the last page with empty rows.

        
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


    
  const handle_row_update = (index, type, value, optionNum) => {

    if(type === 'price' && value < 0){
      return;
    }

   return props.set_all_shipping_services((previousshipping_services) => {

      const temp_options = [...previousshipping_services];

      temp_options[index][type] = value;

      return(props.set_all_shipping_services(temp_options))

    })

  }

  const handle_shipping_service_state = (type) => {

    if(type === "edit"){

    const shipping_service = props.all_shipping_services.filter((shipping_service) => shipping_service.is_checked === true)

    if(shipping_service.length > 0){

      console.log('shipping_service was', shipping_service)

      props.set_dialog_shipping_service({...shipping_service[0]}, true)

    }else{
      console.log("Error getting shipping_service")
    }

  }

  }


  

  return (
    <>
    {props.all_shipping_services.length > 0 ? <Box sx={{ width: '100%'}} style={{marginTop:20}}>
      <Paper sx={{ width: '100%', mb: 2 }} >
        <EnhancedTableToolbar numSelected={selected} delete_shipping_services={props.delete_shipping_services} handle_shipping_service_state={handle_shipping_service_state} />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={props.all_shipping_services.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {props.all_shipping_services.map((shipping_service, index) => {


              return(

                <TableRow
                      hover
                    // onClick={(event) => handleClick(event, option_value.value)}
                      role="checkbox"
                      //aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                    // selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={shipping_service.is_checked}
                          onChange={(event) => {handle_row_update(index,"is_checked",event.target.checked,index)}}
                          /*
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                          */
                        />
                      </TableCell>
                      <TableCell align="left" style={{paddingRight:0}}>
                      <Avatar
                        sx={{
                          height: 40,
                          width: 40,
                          ml: 'auto',
                          mr:'auto'
                        }}
                        src="/static/images/food-truck.png"
                      >

                    </Avatar>
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{minWidth:160}}
                      >
                        <strong>{shipping_service.Courier}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.Warehouse}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.Country}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.ParcelifyName}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.ServiceName}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.ShopifyReference}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.Currency}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.SnagPriceBase}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.SnagPriceVAT}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.SnagPricePerKG}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.CourierBasePrice}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.CourierPerKG}</strong>
                      </TableCell>
                      <TableCell align="left">
                      <strong>{shipping_service.CourierBasePrice6}</strong>
                      </TableCell>
                    </TableRow>
                      
                
                  );


                 
              })}
              
            </TableBody>
          </Table>
        </TableContainer>
    
      </Paper>
      
    </Box> : null}
    </>
  );
}


export default React.memo(ShippingServicesListTable);